import React from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import Loading from 'zignal-landscape/lib/Loading';
import { Light } from 'themes';
import ThemeProvider from 'zignal-landscape/lib/ThemeProvider';
import CustomStory from 'zignal-widgets/lib/Story/CustomStory';
import noop from 'lodash/noop';

function Stories ({
  stories = [],
  onLoadMore = noop,
  hasMore = false,
  scrollParentRef
}) {
  if (!stories || (Array.isArray(stories) && !stories.length)) {
    return (
      <div style={{ margin: '0 auto', paddingRight: '18px' }}>
        <h5>No results found.</h5>
      </div>
    );
  }

  return (
    <InfiniteScroll
      loadMore={onLoadMore}
      initialLoad={false}
      hasMore={hasMore}
      loader={(
        <div key={1} style={{textAlign: 'center', padding: '40px', position: 'relative', height: '80px'}}>
          <Loading />
        </div>
      )}
      threshold={1000}
      useWindow={false}
      getScrollParent={() => scrollParentRef}
    >
      <div style={{ margin: '0 auto', paddingRight: '18px' }}>
        {stories.map(story => (
          <div key={story.story_id} style={{ padding: '12px 0 12px 0', width: '100%' }}>
            <ThemeProvider theme={Light}>
              <CustomStory
                story={story}
                isStoryCard
              />
            </ThemeProvider>
          </div>
        ))
        }
      </div>
    </InfiniteScroll>
  );
}

Stories.propTypes = {
  stories: PropTypes.array,
  onLoadMore: PropTypes.func,
  hasMore: PropTypes.bool,
};

export default Stories;
